import { PENDING } from "../actions";

const defaultState = {
  loading: false,
  error: false,
  filters: [],
  pageIndex: 0,
  sort: "",
  desc: false,
  showSuccessMessage: false,
  deleteStatus: "IDLE"
};

const fetch = state => ({ ...state, loading: true, error: false });
const fetchSuccess = (state, action) => ({
  ...state,
  loading: false,
  error: false,
  pending: action.payload
});
const fetchError = state => ({ ...state, loading: false, error: true });
const setFilters = (state, { payload }) => ({ ...state, filters: payload });
const setPageIndex = (state, { payload }) => ({ ...state, pageIndex: payload });
const setSortColumn = (state, { payload }) => ({ ...state, sort: payload });
const setSortDesc = (state, { payload }) => ({ ...state, desc: payload });
const deleteAll = state => ({ ...state, loading: true });

const ACTION_HANDLERS = {
  [PENDING.FETCH]: fetch,
  [PENDING.DELETE_TRANSFER_ALL]: deleteAll,
  [PENDING.FETCH_SUCCESS]: fetchSuccess,
  [PENDING.FETCH_ERROR]: fetchError,
  [PENDING.SET_FILTER]: setFilters,
  [PENDING.SET_PAGE_INDEX]: setPageIndex,
  [PENDING.SET_SORT_COLUMN]: setSortColumn,
  [PENDING.SET_SORT_DESC]: setSortDesc
};

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
